import { Component, AfterViewInit, ElementRef, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef, HostListener } from '@angular/core';  
import { ConfettiService } from 'src/app/services/confetti.service';
  
@Component({  
  selector: 'app-banner-dow-one-hundred-k',  
  templateUrl: './banner-dow-one-hundred-k.component.html',  
  styleUrls: ['./banner-dow-one-hundred-k.component.scss'],  
  changeDetection: ChangeDetectionStrategy.OnPush ,
  standalone:false 
})  
export class BannerDowOneHundredKComponent implements AfterViewInit {  

  
  @ViewChild('confettiDiv', { static: true }) confettiDiv!: ElementRef;  

  constructor(private confettiService: ConfettiService, private cdr: ChangeDetectorRef) {}  

  ngAfterViewInit() {  
    this.confettiService.startFireworks(this.confettiDiv.nativeElement);  
  }  

  ngOnDestroy() {  
    this.confettiService.stopFireworks();  
  }  

}  
